// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"LoadingSpinner_loadingWrapper__Nsl94","darkMode":"LoadingSpinner_darkMode__FmEu2"};